export default {
  printedPdf: 'Printed PDF',
  downloadedPdf: 'Downloaded PDF',
}
